import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import 'react-toastify/dist/ReactToastify.css';
import 'rc-time-picker/assets/index.css';

import "../src/Style/global.scss";
import "../src/Style/style.scss";
import "../src/Style/responsive.scss";

import Store from './Store/store';
import { Provider } from 'react-redux';

if (process.env.REACT_APP_DOMAIN !== "localhost") {
  console.log = function () { };
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={Store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
